import { createDeliveryClient } from '@kontent-ai/delivery-sdk';

const getKontentClient = (previewEnabled) => {
  return createDeliveryClient({
    environmentId: process.env.KONTENTAI_ENVIRONMENT_ID,
    ...(previewEnabled
      ? {
          previewApiKey: process.env.KONTENTAI_DELIVERY_API_KEY,
          defaultQueryConfig: {
            usePreviewMode: true,
            useSecuredMode: false
          }
        }
      : {
          secureApiKey: process.env.KONTENTAI_SECURE_DELIVERY_API_KEY,
          defaultQueryConfig: {
            usePreviewMode: false,
            useSecuredMode: true
          }
        })
  });
};

export default getKontentClient;
